import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import * as myCfg from '../AppConfig';
import { APIContainer, LogTypes, sawinFunc } from './sawinLib';
import { SessionModel } from '../models/SessionModel';
import * as DocumentMdl from '../models/AzureDocumentModel';
//import { AdditionalUserListListLoadInfo } from './AdditionalUserListList';
// -----------------
// STATE - This defines the type of data maintained in the Redux store.


export interface AzureDocumentsLoading { type: 'AZUREDOCUMENTS_LOADING', loading: boolean }
export interface AzureDocumentsError { type: 'AZUREDOCUMENTS_ERROR', error: string }
export interface AzureDocumentsLoadInfo { type: 'AZUREDOCUMENTS_LOADINFO', data: DocumentMdl.AzureDocumentList }
export interface AzureDocumentsReset { type: 'AZUREDOCUMENTS_RESET' }

export type KnownAction = AzureDocumentsLoading | AzureDocumentsError | AzureDocumentsLoadInfo | AzureDocumentsReset;

export const actionCreators = {
    retrieve: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        const sessionState = appState.sessionState;

        const CompanyCode = sessionState.SelectedAR.companyCode;
        const ServiceMasterNum = sessionState.SelectedSM.id;


        dispatch({ type: 'AZUREDOCUMENTS_LOADING', loading: true }); 
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + `api/Proxy/AzureDocuments?CompanyCode=${CompanyCode}&EntityCode=${ServiceMasterNum}&EntityType=14`,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {
                //Do something with response                
                if (container.success) {
                    const data: DocumentMdl.AzureDocument[] = container.data;
                    dispatch({ type: 'AZUREDOCUMENTS_LOADINFO', data: { items: data, loading: false, error: '' } });
                } else {
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                    dispatch({
                        type: 'AZUREDOCUMENTS_ERROR', error: container.errorInfo.message
                    })
                }

            })
            .catch(function (err: Error) {
                dispatch({
                    type: 'AZUREDOCUMENTS_ERROR', error: err.message
                })
            });
    },  
    resetState: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({ type: "AZUREDOCUMENTS_RESET" });
    }
};

export const reducer: Reducer<DocumentMdl.AzureDocumentList> = (state: DocumentMdl.AzureDocumentList | undefined, incomingAction: Action): DocumentMdl.AzureDocumentList => {

    if (state === undefined) {
        return { ...DocumentMdl.initialListState };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'AZUREDOCUMENTS_LOADING':
            return { ...state, loading: (action as AzureDocumentsLoading).loading }
        case 'AZUREDOCUMENTS_ERROR':
            return { ...state, loading: false, error: (action as AzureDocumentsError).error }
        case 'AZUREDOCUMENTS_LOADINFO':
            return { ...state, ...(action as AzureDocumentsLoadInfo).data }
        case 'AZUREDOCUMENTS_RESET':
            return { ...state, ...DocumentMdl.initialListState }
        default:
            return state;
    }
};